import { LoadingComponentProps } from 'react-loadable';

import { Layout } from 'layouts/Layout';
import { ErrorPage } from 'modules/main/pages/Error';

import { LoadingPage } from './LoadingPage';

export function LoadingPageLoadable({
  error,
  pastDelay,
}: LoadingComponentProps) {
  if (error) {
    return <ErrorPage error={error} />;
  }

  if (pastDelay) {
    return <LoadingPage delay={0} />;
  }

  return <Layout />;
}
